/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/video-quality.css';
import config from '../../../../config';

// Video quality translation taken from https://phenixrts.com/docs/api/#supported-quality-capabilities
const videoQualityMap = {
  uld: '144',
  vld: '240',
  ld: '350',
  sd: '480',
  hd: '720',
  fhd: '1080'
};
export const VideoQualityButton = ({toggleVideoSettings, isQualityListShown, setVideoQuality, selectedVideoQuality}) => (
  <div className={styles.videoQualityButtonContainer}>
    <i
      id="videoQuality"
      onClick={toggleVideoSettings}
      title={'Settings'}
      className={styles.videoQualityButton}
    />
    {isQualityListShown && (
      <div className={styles.videoQualitySettings}>
        <div className={styles.videoQualityText}>Quality</div>
        {config.qualities.slice().reverse().map((quality) => (
          videoQualityMap[quality] ? (
            <div key={quality} className={selectedVideoQuality === quality ? styles.selectedVideoQuality : ''} onClick={() => setVideoQuality(quality)}>
              {videoQualityMap[quality]}p<span>{parseInt(videoQualityMap[quality]) >= 720 ? 'HD' : '' }</span>
            </div>
          ) : null
        ))}
      </div>
    )}
  </div>
);

VideoQualityButton.propTypes = {
  isQualityListShown: PropTypes.bool.isRequired,
  toggleVideoSettings: PropTypes.func.isRequired,
  setVideoQuality: PropTypes.func.isRequired,
  selectedVideoQuality: PropTypes.string.isRequired
};

export default VideoQualityButton;